import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { useState } from "react";
import { IDropArea } from "../PropertyDetailApplications";
import { DragAndDropContext } from "./DragAndDropContext";

interface IProps {
  children: React.ReactNode;
}

export const DragAndDropContextProvider = ({ children }: IProps) => {
  const [selectedItems, setSelectedItems] = useState<IApplication[]>([]);
  const [allDropAreas, setAllDropAreas] = useState<IDropArea[]>([]);

  const onSelectItem = (item: IApplication) => {
    setSelectedItems([...selectedItems, item]);
  };

  const onSelectAll = (items: IApplication[]) => {
    setSelectedItems(items);
  };

  const onUnselectItem = (item: IApplication) => {
    setSelectedItems(selectedItems.filter(i => i.id !== item.id));
  };

  const onUnselectAll = (items: IApplication[]) => {
    const itemIds = items.map(item => item.id);
    setSelectedItems(selectedItems.filter(i => !itemIds.includes(i.id)));
  };

  const replaceSelectedItems = (items: IApplication[]) => {
    setSelectedItems(items);
  };

  return (
    <DragAndDropContext.Provider
      value={{
        selectedItems,
        allDropAreas,
        onSelectItem,
        onSelectAll,
        onUnselectItem,
        onUnselectAll,
        replaceSelectedItems,
        setAllDropAreas,
      }}
    >
      {children}
    </DragAndDropContext.Provider>
  );
};
